/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const PowerpointLearnMoreActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.LearnMore,
    checked: false,
    primaryContent: strings.getString('trialconversionPowerpointLearnMoreHeader'),
    secondaryContent: strings.getString('trialconversionPowerpointLearnMoreContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionPowerpointCard', 'Learn more clicked'),
    retriggerable: true
});
